import { AppLayout, ContentLayout, Flashbar, Header } from '@amzn/awsui-components-react';
import React, { useContext } from 'react';
import { DashboardListWithWaitlistedTab } from './DashboardListWithWaitlistedTab';
import { APPLICATION_NAME, getBreadcrumbItemsFromLocation, getNodeEnvironment, useSaveSurveyResponse } from '../../common';
import { Breadcrumbs, Navigation, NotificationContext } from '../../components';
import { IltLearnerAssistantLayout } from '../../components/AIChatbot/IltLearnerAssistantLayout';
import { FlagNames, isFeatureEnabled, Stages } from '@amzn/aws-tc-ilt-common';

const Content = () => {
    document.title = APPLICATION_NAME;
    const isChatbotEnabled = isFeatureEnabled(FlagNames.MYCLASS_AI_CHATBOT, getNodeEnvironment() as Stages);

    const dashboardContent = (
        <ContentLayout
            header={
                <Header
                    variant='h1'
                    description='You can view the list of all classes available in your dashboard,
                    and once you have enrolled in the class, you will be able to join it when the class begins.'
                >
                    My Dashboard
                </Header>
            }
        >
            <DashboardListWithWaitlistedTab />
        </ContentLayout>
    );

    return isChatbotEnabled ? <IltLearnerAssistantLayout>{dashboardContent}</IltLearnerAssistantLayout> : dashboardContent;
};

export const Dashboard = () => {
    const { notifications } = useContext(NotificationContext);
    useSaveSurveyResponse();
    return (
        <AppLayout
            content={<Content />}
            navigation={<Navigation />}
            contentType={'wizard'}
            notifications={<Flashbar items={notifications} />}
            toolsHide={true}
            breadcrumbs={<Breadcrumbs items={getBreadcrumbItemsFromLocation('home')} />}
        />
    );
};
